import {
  localizedNumber,
  returnSingularOrPlural,
} from "../../../../../utils/help/localization/localization";
import ConfettiComponent from "../../../../global/AnimatedConffeti/AnimatedConfettiComponent";
import { MileStone } from "../../../../global/Icons/loyalty.icons";
import { LoyaltyPointsExpiryBanner } from "../../LoyaltyPointsExpiryBanner/LoyaltyPointsExpiryBanner";
import { LoyaltyPointsProgressBar } from "../../LoyaltyPointsProgressBar/LoyaltyPointsProgressBar";
import styles from "../LoyaltyPointsLoyaltySection.module.scss";

interface LegacyLoyaltyPointsHeaderProps {
  isMainDark: boolean;
  totalBalanceText: string;
  isSignedIn: boolean;
  displayPoints: number;
  pointName: string;
  signedOutText: string;
  collectText: string;
  displayPointsPerCredit?: number;
  forEveryText: string;
  currency: string;
  youSpendText: string;
  termsText: string;
  onViewTerms: () => void;
  isPayWithPointsMechanism: boolean;
}

export const LegacyLoyaltyPointsHeader = ({
  isMainDark,
  totalBalanceText,
  isSignedIn,
  displayPoints,
  pointName,
  signedOutText,
  collectText,
  displayPointsPerCredit,
  forEveryText,
  currency,
  youSpendText,
  termsText,
  onViewTerms,
  isPayWithPointsMechanism,
}: LegacyLoyaltyPointsHeaderProps) => (
  <>
    <div className={styles.confetti} data-testid="confetti-div">
      <ConfettiComponent tierTint darkColor={isMainDark} />
    </div>
    <div className={styles.root}>
      <div className={styles.current_points_section}>
        <h1 className={styles.title} data-testid="pointing-title">
          {totalBalanceText}
        </h1>
        {isSignedIn ? (
          <span className={styles.points_span} data-testid="pointing-points">
            <p className={styles.points_number}>
              {`${localizedNumber(displayPoints)} `}
            </p>
            <p className={styles.points_text}>
              {returnSingularOrPlural(pointName, displayPoints)} <MileStone />
            </p>
          </span>
        ) : (
          <span className={styles.points_span} data-testid="pointing-points">
            {signedOutText}
          </span>
        )}
        <LoyaltyPointsExpiryBanner />
        {!isPayWithPointsMechanism && <LoyaltyPointsProgressBar />}
      </div>

      <div
        data-testid="pointing-how-it-works"
        className={styles.how_it_works_section}
      >
        <div className={styles.rules_span}>
          <p>{collectText}</p>{" "}
          <p className={styles.point_per_credit}>
            {`${localizedNumber(
              displayPointsPerCredit
            )} ${returnSingularOrPlural(pointName, displayPointsPerCredit)}`}
          </p>{" "}
          <p>{forEveryText}</p>{" "}
          <p className={styles.bold_text}>{`${localizedNumber(
            1
          )}${currency}`}</p>{" "}
          <p> {youSpendText}...</p>
        </div>
        <div
          onClick={onViewTerms}
          className={styles.terms_link}
          data-testid="learn-more-btn"
        >
          {termsText}
        </div>
      </div>
    </div>
  </>
);
